export const startDate = new Date(new Date().getFullYear() - 1, 0, 1);
export const endDate = new Date(new Date().getFullYear() + 3, 11, 31);
